@if (form) {
  <div class="m-4">

    <div class="form-group sfk-form-vertical-spacer col mt-0 mb-0">
      <app-custom-select
        id="schoolId"
        [class]="'sfk-ellipsed-ng-select'"
        [customFormGroup]="form"
        placeholder="-"
        [items]="schuleList"
        [multiple]="false"
        [clearable]="false"
        bindLabel="name"
        bindValue="schuleId"
        [label]="'SCHOOL_DATA.SCHOOL' | translate"
        [noteText]="'SCHOOL_DATA.FIELD_ERROR.REQUIRED' | translate"
        [attr.data-cy]="testIdPrefix + 'schule'">
      </app-custom-select>
    </div>

    <div class="form-group sfk-form-vertical-spacer col mt-0 mb-0">
      <app-custom-select
        id="schulTyp"
        [class]="'sfk-ellipsed-ng-select'"
        [customFormGroup]="form"
        placeholder="-"
        [items]="schoolTypeOptions"
        [multiple]="false"
        [clearable]="false"
        bindLabel="label"
        bindValue="value"
        [label]="'SCHOOL_DATA.SCHOOL_TYPE' | translate"
        [readonly]="true"
        [attr.data-cy]="schoolTypeTestId">
      </app-custom-select>
    </div>

    @if (isVocational()) {
      <div class="form-group sfk-form-vertical-spacer col mt-0 mb-0">
        <app-custom-select
          id="courseId"
          [class]="'sfk-ellipsed-ng-select'"
          [customFormGroup]="form"
          placeholder="-"
          [items]="filteredBildungsgangList"
          [multiple]="false"
          [clearable]="true"
          bindLabel="name"
          bindValue="bildungsgangId"
          [label]="'SCHOOL_DATA.COURSE' | translate"
          [attr.data-cy]="testIdPrefix + 'bildungsgang'">
        </app-custom-select>
      </div>
    }

    <div class="form-group sfk-form-vertical-spacer col mt-0 mb-0">
      <app-custom-select
        id="schoolYearId"
        [class]="'sfk-ellipsed-ng-select'"
        [customFormGroup]="form"
        placeholder="-"
        [items]="filteredSchuljahreList"
        [multiple]="false"
        [clearable]="false"
        bindLabel="name"
        bindValue="schuljahrId"
        [label]="'SCHOOL_DATA.SCHOOL_YEAR' | translate"
        [noteText]="'SCHOOL_DATA.FIELD_ERROR.REQUIRED' | translate"
        [attr.data-cy]="testIdPrefix + 'schuljahr'">
      </app-custom-select>
    </div>

    @if (!isVocational()) {
      <div class="form-group sfk-form-vertical-spacer col mt-0 mb-0">
        <app-custom-select
          id="classId"
          [class]="'sfk-ellipsed-ng-select'"
          [customFormGroup]="form"
          placeholder="-"
          [items]="filteredKlassenList"
          [multiple]="false"
          [clearable]="true"
          bindLabel="name"
          bindValue="klasseId"
          [label]="'SCHOOL_DATA.KLASSE' | translate"
          [attr.data-cy]="testIdPrefix + 'klasse'">
        </app-custom-select>
      </div>
    }

  </div>
}
